'use client';

import { faClipboardList, faClose } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslations } from 'use-intl';

import { Button, FaIcon } from '@/shared-ui';

import { useHandsFreeQuestionPopupContext } from './project-usability-handsfree-question-popup-context';

interface Props {
  onClose?: () => void;
  disabled?: boolean;
}

export default function ProjectUsabilityHandsFreeQuestionPopupHeader({
  onClose,
  disabled = false,
}: Props) {
  const t = useTranslations('UserTest');

  const { currentQuestionIndex, totalQuestions } =
    useHandsFreeQuestionPopupContext();
  const questionNumber = currentQuestionIndex + 1;

  return (
    <div className='flex items-center justify-between gap-2'>
      <div className='flex min-w-0 items-center gap-2'>
        <FontAwesomeIcon
          icon={faClipboardList}
          className='size-3 shrink-0 text-gray-500'
          aria-hidden='true'
        />
        <span className='text-[10px]/4.5 font-semibold text-gray-500'>
          {t('task.counter', {
            current: questionNumber,
            total: totalQuestions,
          })}
        </span>
      </div>
      {onClose && (
        <Button
          variant='ghost'
          size='icon'
          type='button'
          onClick={onClose}
          disabled={disabled}
          className='size-auto shrink-0 rounded p-1 text-gray-400 hover:enabled:bg-gray-100 hover:enabled:text-gray-600'
          aria-label={t('task.minimizePanel')}
          data-test='handsfree-task-panel-close'
        >
          <FaIcon icon={faClose} size={3.5} />
        </Button>
      )}
    </div>
  );
}
